import axios from 'smg/axios';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';

export default function main() {
    const $form = document.querySelector<HTMLFormElement>('#download-form');

    if ($form) {
        const $email = $form.querySelector('#download-email') as HTMLInputElement;
        const $firstName = $form.querySelector('#download-name') as HTMLInputElement;
        const $phone = $form.querySelector('#download-tel') as HTMLInputElement;

        const $alert = document.querySelector('#download-alert') as HTMLElement;

        const p = new Phone($phone);

        $form.noValidate = true;
        $form.addEventListener('submit', async e => {
            e.preventDefault();
            if (!ReportValidity($form)) {
                return;
            }
            await axios.post('/users/email', {
                email: $email.value,
                firstName: $firstName.value,
                phone: await p.Format(),
                form: 'sig-download-design-template',
            }).then(() => {
                $alert.classList.remove('d-none');
                $alert.classList.add('alert-success');
                $alert.innerHTML = 'Thank you for your interest! We will be in touch soon.';
            }).catch(() => {
                $alert.classList.remove('d-none');
                $alert.classList.add('alert-danger');
                $alert.innerHTML = 'There was an error processing your request. Please try again later.';
            });
        });
    }
}
